import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useEventSettings} from '../../../../../../data/hooks/events/useEventSettings';
import Tab from '../../../../../elements/Tabs/Tab';
import Icon from '../../../../../elements/icons/Icon';
import {isTextSearchFilterTabActive} from './isTextSearchFilterTabActive';
import {useHashTriggeredEffect} from '../../../../../../misc/useHashTriggeredEffect/useHashTriggeredEffect';

export const HASHTRIGGER_TEXT_SEARCH = 'textSearch';

const TEXT_SEARCH_FILTER = {
    text: '',
};

function TextSearchParticipants(props) {
    const {className = '', filterParams, eventId} = props,
        selected = isTextSearchFilterTabActive(filterParams),
        settings = useEventSettings(eventId),
        dispatch = useDispatch();

    const openTextSearchTab = useCallback(() => {
        dispatch(app.actions.participants.setFilterParams(eventId, TEXT_SEARCH_FILTER));
    }, [eventId]);

    useHashTriggeredEffect(HASHTRIGGER_TEXT_SEARCH, openTextSearchTab);

    return (
        <Tab className={className} selected={selected} onClick={openTextSearchTab}>
            <Icon src="/img/search_icon_white.png" color={selected ? 'white' : settings.secondary_color} />
        </Tab>
    );
}

export default TextSearchParticipants;
